import { __spreadArrays } from "tslib";
import { fuse } from './fuse';
var defaultMerge = function (latestSnapshot) { return latestSnapshot; };
var MissingToken = Symbol();
export function mergeLatest(source, merge) {
    if (merge === void 0) { merge = defaultMerge; }
    var fallback = [];
    // This needs a fuse instead of select, as there's no guarantee that a
    // select will actually be called with every value.
    var _a = fuse(function (use) {
        var value = use.apply(void 0, __spreadArrays([source], fallback));
        var valueOrFlag = use(source, MissingToken);
        fallback = [value];
        return merge(value, valueOrFlag === MissingToken);
    }), core = _a[0], select = _a[1];
    return [core, select, source[2]];
}
